/* @flow */
// typecheck: ignore file
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SchoolTableBody from 'admin/components/SchoolTableBody.jsx';
import { initializeTable, loadSchools } from 'reducers/schoolTables';
import Organization from 'entities/Organization';

const PER_PAGE = 20;

type Props = {
  sort: string,
  districtId: number,
  disabled: boolean,

  /* redux props */
  initialized: boolean,
  loadSchools: (districtId: number, options: any) => any,
  initializeTable: (districtId: number) => any,
  initialized: boolean,
  allLoaded?: boolean,
  schools?: Organization[],
  page?: number,
}

class SchoolTableBodyContainer extends React.Component {
  props: Props;

  componentWillMount() {
    if (!this.props.initialized) {
      this.props.initializeTable(this.props.districtId);
    }
  }

  componentWillUpdate(nextProps: Props) {
    const initialized = !this.props.initialized && nextProps.initialized;
    const newSort = this.props.sort !== nextProps.sort;

    if (initialized || newSort) {
      this.loadPage(1, nextProps);
    }
  }

  loadPage(page: number, nextProps?: Props) {
    const props = nextProps || this.props;

    let sortOptions = {};

    if (props.sort) {
      switch (props.sort) {
        case 'name_asc':
          sortOptions = { sort: 'name', direction: 'asc' };
          break;
        case 'name_desc':
          sortOptions = { sort: 'name', direction: 'desc' };
          break;
        default:
      }
    }

    this.props.loadSchools(this.props.districtId, {
      sortDirection: sortOptions.direction,
      sort: sortOptions.sort,
      perPage: PER_PAGE,
      page,
    });
  }

  loadNextPage = () => this.loadPage(this.props.page + 1);

  render() {
    if (!this.props.initialized) {
      return <tbody />;
    }

    return (
      <SchoolTableBody
        disabled={this.props.disabled}
        schools={this.props.schools}
        allLoaded={this.props.allLoaded}
        loadNextPage={this.loadNextPage}
      />
    );
  }
}

function mapStateToProps(state: any, props: Props) {
  const table = state.schoolTables.get(props.districtId);

  if (!table) {
    return { initialized: false };
  }

  return {
    initialized: true,
    page: table.page,
    schools: table.schools,
    loading: table.loading,
    allLoaded: table.allLoaded,
  };
}

function mapDispatchToProps(dispatch: Function) {
  // $FlowFixMe
  return bindActionCreators({ initializeTable, loadSchools }, dispatch);
}

export { SchoolTableBodyContainer };
export default connect(mapStateToProps, mapDispatchToProps)(SchoolTableBodyContainer);



// WEBPACK FOOTER //
// ./src/admin/containers/SchoolTableBodyContainer.jsx